/**
 * Extra orbit layers for planet skins (rings / accretion disks).
 * Sphere stays full-size in the tap button; deco sits around it and does not receive taps.
 *
 * Ring PNGs are authored with sphere reference radius 0.55 (CSS scales the wrap
 * to 182%); TON-618's disk uses 0.45 so it reaches further out (CSS: 222%).
 */
export const PLANET_ORBITS = {
  planet_ringed_forge: {
    back: 'cos_planet_ring_back.png',
    front: 'cos_planet_ring_front.png',
    spin: true,
    kind: 'forge',
  },
  planet_ton618: {
    back: 'cos_planet_ton618_disk_back.png',
    front: 'cos_planet_ton618_disk_front.png',
    spin: true,
    kind: 'ton618',
  },
};

export function planetOrbit(code) {
  return PLANET_ORBITS[code] || null;
}

/**
 * Sprites laid over the sphere itself and animated by CSS (e.g. the cyclone that
 * turns on Eye of the Storm). Passed in as a CSS var because CRA's css-loader
 * tries to resolve absolute url() paths at build time.
 */
export const PLANET_FX_OVERLAYS = {
  planet_storm_eye: 'cos_planet_storm_swirl.png',
};

export function planetFxOverlay(code) {
  return PLANET_FX_OVERLAYS[code] || null;
}

/**
 * Full-screen thematic atmospheres for premium planet skins on the home tab.
 * Presence of a key = the skin paints the whole clicker screen.
 */
export const PLANET_ATMOSPHERES = {
  planet_ton618: 'void',
  planet_eclipse: 'corona',
  planet_ringed_forge: 'forge',
  planet_twin_suns: 'twins',
  planet_obsidian: 'ash',
  planet_crimson: 'blood',
  planet_storm_eye: 'storm',
  planet_ice_cap: 'frost',
  planet_rust_dawn: 'rust',
};

export function planetAtmosphere(code) {
  return PLANET_ATMOSPHERES[code] || null;
}
